// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-us-page-dual-section-2-holder {
    order: 2;
}

@media(min-width: 992px) {
    .about-us-page-dual-section-1 {
    
    }

    .about-us-page-dual-section-1 .item,
    .about-us-page-dual-section-2 .item {
        max-width: 550px;
    }

    html[dir='ltr'] .about-us-page-dual-section-1,
    html[dir='ltr'] .about-us-page-dual-section-2 {
        padding-left: 90px;
        padding-right: 90px;

    }

    html[dir='rtl'] .about-us-page-dual-section-1,
    html[dir='rtl'] .about-us-page-dual-section-2 {
        padding-left: 90px;
        padding-right: 90px;
    }

    .dual-section-min-height-controller {
        min-height: 400px;
        max-height: 450px;
        /* width: 510px; */

    }

    .dual-section-min-height-controller p {

        margin-top: 36px !important;
        line-height: 1.35;
        letter-spacing: -2%;
    }

}

@media(min-width: 768px) and (max-width:991px) {

    .about-us-page-dual-section-1,
    .about-us-page-dual-section-2 {
        padding-left: 64px;
        padding-right: 64px;
    }

    .about-us-page-dual-section-1 .container,
    .about-us-page-dual-section-1 .container>div,
    .about-us-page-dual-section-2 .container,
    .about-us-page-dual-section-2 .container>div {
        padding: 0 !important;
    }
}


@media(max-width: 767px) {

    .about-us-page-dual-section-1 .container,
    .about-us-page-dual-section-2 .container {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    .about-us-page-dual-section-1 h3,
    .about-us-page-dual-section-2 h3 {
        font-size: 1.25rem !important;
    }

    .about-us-page-dual-section-1 p,
    .about-us-page-dual-section-2 p {
        text-align: left !important;
    }

    html[dir='rtl'] .about-us-page-dual-section-1 p,
    html[dir='rtl'] .about-us-page-dual-section-2 p {
        text-align: right !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/about/components/DualSection.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;AACZ;;AAEA;IACI;;IAEA;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;QAClB,mBAAmB;;IAEvB;;IAEA;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;;IAEtB;;IAEA;;QAEI,2BAA2B;QAC3B,iBAAiB;QACjB,mBAAmB;IACvB;;AAEJ;;AAEA;;IAEI;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;;;;QAII,qBAAqB;IACzB;AACJ;;;AAGA;;IAEI;;QAEI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,4BAA4B;IAChC;AACJ","sourcesContent":[".about-us-page-dual-section-2-holder {\n    order: 2;\n}\n\n@media(min-width: 992px) {\n    .about-us-page-dual-section-1 {\n    \n    }\n\n    .about-us-page-dual-section-1 .item,\n    .about-us-page-dual-section-2 .item {\n        max-width: 550px;\n    }\n\n    html[dir='ltr'] .about-us-page-dual-section-1,\n    html[dir='ltr'] .about-us-page-dual-section-2 {\n        padding-left: 90px;\n        padding-right: 90px;\n\n    }\n\n    html[dir='rtl'] .about-us-page-dual-section-1,\n    html[dir='rtl'] .about-us-page-dual-section-2 {\n        padding-left: 90px;\n        padding-right: 90px;\n    }\n\n    .dual-section-min-height-controller {\n        min-height: 400px;\n        max-height: 450px;\n        /* width: 510px; */\n\n    }\n\n    .dual-section-min-height-controller p {\n\n        margin-top: 36px !important;\n        line-height: 1.35;\n        letter-spacing: -2%;\n    }\n\n}\n\n@media(min-width: 768px) and (max-width:991px) {\n\n    .about-us-page-dual-section-1,\n    .about-us-page-dual-section-2 {\n        padding-left: 64px;\n        padding-right: 64px;\n    }\n\n    .about-us-page-dual-section-1 .container,\n    .about-us-page-dual-section-1 .container>div,\n    .about-us-page-dual-section-2 .container,\n    .about-us-page-dual-section-2 .container>div {\n        padding: 0 !important;\n    }\n}\n\n\n@media(max-width: 767px) {\n\n    .about-us-page-dual-section-1 .container,\n    .about-us-page-dual-section-2 .container {\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n    }\n\n    .about-us-page-dual-section-1 h3,\n    .about-us-page-dual-section-2 h3 {\n        font-size: 1.25rem !important;\n    }\n\n    .about-us-page-dual-section-1 p,\n    .about-us-page-dual-section-2 p {\n        text-align: left !important;\n    }\n\n    html[dir='rtl'] .about-us-page-dual-section-1 p,\n    html[dir='rtl'] .about-us-page-dual-section-2 p {\n        text-align: right !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
